
export function ProfileSection() {
  return (
    <section className="relative py-16 lg:py-32 bg-black overflow-hidden">
      <div className="container mx-auto px-4 sm:px-8 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-10 lg:mb-20">
            <h2 className="font-display text-3xl sm:text-5xl lg:text-7xl text-white mb-3 lg:mb-6 tracking-wider">
              ARTIST PROFILE
            </h2>
            <p
              className="text-neon-blue text-sm lg:text-2xl font-light tracking-wide mb-4 lg:mb-8"
              style={{
                textShadow: "0 0 20px #00d9ff",
              }}
            >
              シンプル・プロフィール - 「地層」風に並べる
            </p>
            <p className="text-gray-400 text-xs lg:text-lg max-w-3xl mx-auto leading-relaxed">
              マルチソース・パーサーで、YouTube / SoundCloud / TikTok / InstagramのURLを読み込み。<br className="hidden sm:block" />
              アーティストの情報を<strong className="text-white">層（レイヤー）</strong>として表示し、深く潜り込むほど詳細が明らかになる。
            </p>
          </div>

          {/* Profile Demo */}
          <div className="relative max-w-4xl mx-auto">
            {/* Strata Layers */}
            <div className="space-y-4 lg:space-y-6">
              {/* Layer 1: Basic Info */}
              <div className="group relative">
                <div
                  className="hidden lg:block absolute -left-8 top-1/2 -translate-y-1/2 w-6 h-0.5 bg-neon-pink"
                  style={{
                    boxShadow: "0 0 10px #ff006e",
                  }}
                />
                <div
                  className="bg-gradient-to-r from-[#1a1a1a] to-[#0f0f0f] rounded-xl lg:rounded-2xl p-4 lg:p-8 border-l-4 border-neon-pink hover:translate-x-1 lg:hover:translate-x-2 transition-all duration-300 cursor-pointer"
                  style={{
                    boxShadow: "0 0 40px rgba(255, 0, 110, 0.2)",
                  }}
                >
                  <div className="flex items-center gap-3 lg:gap-6">
                    <div
                      className="w-14 h-14 lg:w-24 lg:h-24 rounded-xl lg:rounded-2xl bg-gradient-to-br from-neon-pink/30 to-transparent border-2 border-neon-pink flex items-center justify-center flex-shrink-0"
                      style={{
                        boxShadow: "0 0 30px rgba(255, 0, 110, 0.4)",
                      }}
                    >
                      <i className="ri-user-line text-2xl lg:text-4xl text-neon-pink"></i>
                    </div>

                    <div className="flex-1 min-w-0">
                      <p className="text-gray-500 text-[10px] lg:text-xs tracking-widest mb-1 uppercase">
                        Layer 01 / Basic
                      </p>
                      <h3 className="text-white text-lg lg:text-3xl font-bold mb-1">
                        NEON GHOST
                      </h3>
                      <p className="text-gray-400 text-xs lg:text-base">
                        Experimental Electronic / Noise
                      </p>
                    </div>

                    <div className="text-neon-pink hidden sm:block">
                      <i className="ri-arrow-right-line text-xl lg:text-3xl"></i>
                    </div>
                  </div>
                </div>
              </div>

              {/* Layer 2: Location & Activity */}
              <div className="group relative ml-4 lg:ml-12">
                <div
                  className="hidden lg:block absolute -left-8 top-1/2 -translate-y-1/2 w-6 h-0.5 bg-neon-green"
                  style={{
                    boxShadow: "0 0 10px #00ff41",
                  }}
                />
                <div
                  className="bg-gradient-to-r from-[#1a1a1a] to-[#0f0f0f] rounded-xl lg:rounded-2xl p-4 lg:p-8 border-l-4 border-neon-green hover:translate-x-1 lg:hover:translate-x-2 transition-all duration-300 cursor-pointer"
                  style={{
                    boxShadow: "0 0 40px rgba(0, 255, 65, 0.2)",
                  }}
                >
                  <div className="flex items-center gap-3 lg:gap-6">
                    <div
                      className="w-14 h-14 lg:w-24 lg:h-24 rounded-xl lg:rounded-2xl bg-gradient-to-br from-neon-green/30 to-transparent border-2 border-neon-green flex items-center justify-center flex-shrink-0"
                      style={{
                        boxShadow: "0 0 30px rgba(0, 255, 65, 0.4)",
                      }}
                    >
                      <i className="ri-map-pin-line text-2xl lg:text-4xl text-neon-green"></i>
                    </div>

                    <div className="flex-1 min-w-0">
                      <p className="text-gray-500 text-[10px] lg:text-xs tracking-widest mb-1 uppercase">
                        Layer 02 / Location
                      </p>
                      <h4 className="text-white text-base lg:text-2xl font-bold mb-1">
                        TOKYO
                      </h4>
                      <p className="text-gray-400 text-xs lg:text-base">
                        渋谷・下北沢エリアで活動中
                      </p>
                      <div className="flex gap-2 mt-2">
                        <span className="px-2 lg:px-3 py-0.5 lg:py-1 bg-neon-green/20 rounded-full text-neon-green text-[10px] lg:text-xs">
                          ライブ活動中
                        </span>
                        <span className="px-2 lg:px-3 py-0.5 lg:py-1 bg-white/10 rounded-full text-gray-400 text-[10px] lg:text-xs">
                          新曲制作中
                        </span>
                      </div>
                    </div>

                    <div className="text-neon-green hidden sm:block">
                      <i className="ri-arrow-right-line text-xl lg:text-3xl"></i>
                    </div>
                  </div>
                </div>
              </div>

              {/* Layer 3: Music Platforms */}
              <div className="group relative ml-8 lg:ml-24">
                <div
                  className="hidden lg:block absolute -left-8 top-1/2 -translate-y-1/2 w-6 h-0.5 bg-neon-blue"
                  style={{
                    boxShadow: "0 0 10px #00d9ff",
                  }}
                />
                <div
                  className="bg-gradient-to-r from-[#1a1a1a] to-[#0f0f0f] rounded-xl lg:rounded-2xl p-4 lg:p-8 border-l-4 border-neon-blue hover:translate-x-1 lg:hover:translate-x-2 transition-all duration-300 cursor-pointer"
                  style={{
                    boxShadow: "0 0 40px rgba(0, 217, 255, 0.2)",
                  }}
                >
                  <div className="flex items-center gap-3 lg:gap-6">
                    <div
                      className="w-14 h-14 lg:w-24 lg:h-24 rounded-xl lg:rounded-2xl bg-gradient-to-br from-neon-blue/30 to-transparent border-2 border-neon-blue flex items-center justify-center flex-shrink-0"
                      style={{
                        boxShadow: "0 0 30px rgba(0, 217, 255, 0.4)",
                      }}
                    >
                      <i className="ri-music-line text-2xl lg:text-4xl text-neon-blue"></i>
                    </div>

                    <div className="flex-1 min-w-0">
                      <p className="text-gray-500 text-[10px] lg:text-xs tracking-widest mb-2 uppercase">
                        Layer 03 / Music Sources
                      </p>
                      <div className="grid grid-cols-2 gap-2 lg:gap-3">
                        {[
                          {
                            name: "YouTube",
                            icon: "ri-youtube-line",
                            color: "#ff0000",
                          },
                          {
                            name: "SoundCloud",
                            icon: "ri-soundcloud-line",
                            color: "#ff8800",
                          },
                          {
                            name: "Spotify",
                            icon: "ri-spotify-line",
                            color: "#1db954",
                          },
                          {
                            name: "Instagram",
                            icon: "ri-instagram-line",
                            color: "#e4405f",
                          },
                        ].map((platform, index) => (
                          <a
                            key={index}
                            href="#"
                            className="flex items-center gap-2 lg:gap-3 px-2 lg:px-4 py-2 lg:py-3 bg-black/50 rounded-lg border border-white/10 hover:border-neon-blue hover:bg-white/5 transition-all duration-300 group/link"
                          >
                            <i
                              className={`${platform.icon} text-base lg:text-xl text-gray-400 group-hover/link:text-neon-blue transition-colors`}
                            ></i>
                            <span className="text-gray-400 text-[10px] lg:text-sm group-hover/link:text-white transition-colors">
                              {platform.name}
                            </span>
                          </a>
                        ))}
                      </div>
                    </div>

                    <div className="text-neon-blue hidden sm:block">
                      <i className="ri-arrow-right-line text-xl lg:text-3xl"></i>
                    </div>
                  </div>
                </div>
              </div>

              {/* Layer 4: Social & Contact */}
              <div className="group relative ml-12 lg:ml-36">
                <div
                  className="hidden lg:block absolute -left-8 top-1/2 -translate-y-1/2 w-6 h-0.5 bg-neon-purple"
                  style={{
                    boxShadow: "0 0 10px #b537f2",
                  }}
                />
                <div
                  className="bg-gradient-to-r from-[#1a1a1a] to-[#0f0f0f] rounded-xl lg:rounded-2xl p-4 lg:p-8 border-l-4 border-neon-purple hover:translate-x-1 lg:hover:translate-x-2 transition-all duration-300 cursor-pointer"
                  style={{
                    boxShadow: "0 0 40px rgba(181, 55, 242, 0.2)",
                  }}
                >
                  <div className="flex items-center gap-3 lg:gap-6">
                    <div
                      className="w-14 h-14 lg:w-24 lg:h-24 rounded-xl lg:rounded-2xl bg-gradient-to-br from-neon-purple/30 to-transparent border-2 border-neon-purple flex items-center justify-center flex-shrink-0"
                      style={{
                        boxShadow: "0 0 30px rgba(181, 55, 242, 0.4)",
                      }}
                    >
                      <i className="ri-links-line text-2xl lg:text-4xl text-neon-purple"></i>
                    </div>

                    <div className="flex-1 min-w-0">
                      <p className="text-gray-500 text-[10px] lg:text-xs tracking-widest mb-2 uppercase">
                        Layer 04 / Social Links
                      </p>
                      <div className="flex gap-2 lg:gap-3">
                        {["twitter", "facebook", "tiktok", "discord"].map(
                          (social, index) => (
                            <a
                              key={index}
                              href="#"
                              className="w-9 h-9 lg:w-12 lg:h-12 rounded-full bg-black/50 border border-white/10 flex items-center justify-center text-gray-400 hover:text-neon-purple hover:border-neon-purple hover:bg-white/5 transition-all duration-300"
                            >
                              <i
                                className={`ri-${social}-line text-base lg:text-xl`}
                              ></i>
                            </a>
                          )
                        )}
                      </div>
                    </div>

                    <div className="text-neon-purple hidden sm:block">
                      <i className="ri-check-line text-xl lg:text-3xl"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Depth Indicator - hidden on mobile */}
            <div className="hidden lg:flex absolute -left-20 top-0 bottom-0 flex-col justify-between py-8">
              <div className="text-gray-600 text-xs tracking-widest transform -rotate-90 origin-left whitespace-nowrap">
                SURFACE
              </div>
              <div
                className="flex-1 w-px bg-gradient-to-b from-neon-pink via-neon-green via-neon-blue to-neon-purple mx-auto"
                style={{
                  boxShadow: "0 0 10px rgba(255, 255, 255, 0.3)",
                }}
              />
              <div className="text-gray-600 text-xs tracking-widest transform -rotate-90 origin-left whitespace-nowrap">
                DEEP
              </div>
            </div>
          </div>

          {/* Features */}
          <div className="mt-12 lg:mt-20 grid grid-cols-3 gap-4 lg:gap-8">
            <div className="text-center">
              <div
                className="w-12 h-12 lg:w-16 lg:h-16 rounded-full bg-neon-pink/20 border-2 border-neon-pink flex items-center justify-center mx-auto mb-2 lg:mb-4"
                style={{
                  boxShadow: "0 0 30px rgba(255, 0, 110, 0.3)",
                }}
              >
                <i className="ri-layout-line text-lg lg:text-2xl text-neon-pink"></i>
              </div>
              <h4 className="text-white text-xs lg:text-lg font-bold mb-1 lg:mb-2">
                レイヤー構造
              </h4>
              <p className="text-gray-400 text-[10px] lg:text-sm">
                情報を層として表示し、深く潜るほど詳細が明らかに
              </p>
            </div>

            <div className="text-center">
              <div
                className="w-12 h-12 lg:w-16 lg:h-16 rounded-full bg-neon-green/20 border-2 border-neon-green flex items-center justify-center mx-auto mb-2 lg:mb-4"
                style={{
                  boxShadow: "0 0 30px rgba(0, 255, 65, 0.3)",
                }}
              >
                <i className="ri-link-m text-lg lg:text-2xl text-neon-green"></i>
              </div>
              <h4 className="text-white text-xs lg:text-lg font-bold mb-1 lg:mb-2">
                マルチソース対応
              </h4>
              <p className="text-gray-400 text-[10px] lg:text-sm">
                主要な音楽プラットフォームのURLを自動解析
              </p>
            </div>

            <div className="text-center">
              <div
                className="w-12 h-12 lg:w-16 lg:h-16 rounded-full bg-neon-blue/20 border-2 border-neon-blue flex items-center justify-center mx-auto mb-2 lg:mb-4"
                style={{
                  boxShadow: "0 0 30px rgba(0, 217, 255, 0.3)",
                }}
              >
                <i className="ri-share-line text-lg lg:text-2xl text-neon-blue"></i>
              </div>
              <h4 className="text-white text-xs lg:text-lg font-bold mb-1 lg:mb-2">
                簡単シェア
              </h4>
              <p className="text-gray-400 text-[10px] lg:text-sm">
                プロフィールを簡単にシェアして、ファンを増やす
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
